export default __webpack_public_path__ + "static/media/bx-cog.6efbe618.svg";